import {
  InferType,
  object,
  string,
} from '@/validations/custom-yup';
import { halfWidthNumber } from '@/validations/regex';
/** ログイン画面用ログインID */
export const loginLoginIdSchema = string()
  .label('ログインID')
  .required(({ label }) => `${label}を入力してください。`);

/** ログイン画面用パスワード */
export const loginPasswordSchema = string()
  .label('パスワード')
  .required(({ label }) => `${label}を入力してください。`);

/** パスワード再設定用メールアドレス */
export const loginMailAddressSchema = string()
  .label('メールアドレス')
  .required()
  .email('メールアドレスのフォーマットを確認してください。');

/** 認証コード */
export const validateCodeSchema = string()
  .label('認証コード')
  .required(({ label }) => `${label}を入力してください。`)
  .matches(halfWidthNumber, '認証コードは半角数字で入力してください。')
  .length(6, '認証コードは6桁で入力してください。');

export const loginFormSchema = object({
  loginId: loginLoginIdSchema,
  password: loginPasswordSchema,
});

export const mailAuthFormSchema = object({
  validateCode: validateCodeSchema,
});

export type LoginForm = InferType<typeof loginFormSchema>;
export type MailAuthForm = InferType<typeof mailAuthFormSchema>;
